module.exports = __webpack_public_path__ + "img/tarot_shuffle.8ce1fa95.jpg";